<template>
  <div :style="viewStyle">
    <v-row class="ma-0 page-bag" id="router" style="overflow-y:auto" justify="center">
      <div class="page-container my-8">
        <h2 class="text-center page-title">{{$root.LOGININFO.name}} 您好</h2>
        <h2 class="text-center page-subtitle">歡迎使用教職員薪資查詢系統</h2>
        <v-row class="ma-0">
          <v-col cols="12" class="pa-2">
            <div v-if="infoStatus == 1" class="salary-card">
              <v-row no-gutters align="center" class="salary-row header-row">
                <v-col cols="7" class="mb-2" style="display: contents;">
                  <div class="d-flex">
                    <div class="header-text">{{datasets.yearMonth}}</div>
                    <div class="header-text ml-2">薪資明細</div>
                  </div>
                </v-col>
                <v-col class="text-right header-col">
                  <v-btn outlined color="#FFF" style="width: 140px; height:42px; border-radius: 20px; background:#7AC7FC" @click="redirectPath('/payrollHistoryPage/', datasets.id)">
                    <div class="caption-text pl-2">詳細資訊</div>
                    <v-icon size="28px" color="#FFF">mdi-menu-right</v-icon>
                  </v-btn>
                </v-col>
              </v-row>
              <div class="amount-wrapper">
                <div class="amount-block">
                  <div class="caption-text">應發合計</div>
                  <div class="amount-text">{{ formatMoney(datasets.totalPayable) }}</div>
                </div>
                <div class="operator">－</div>
                <div class="amount-block">
                  <div class="caption-text">應扣合計</div>
                  <div class="amount-text">{{ formatMoney(datasets.totalDeduction) }}</div>
                </div>
                <div class="operator">＝</div>
                <div class="amount-block result-block">
                  <div class="caption-text" style="color: #d32f2f;">實發金額</div>
                  <div class="amount-text">{{ formatMoney(datasets.netPay) }}</div>
                </div>
              </div>
            </div>
            <div v-if="infoStatus == 2" class="salary-card">
              <h2 class="text-center py-10" style="font-size: 1.6rem; font-weight: 700;">目前沒有薪資資訊</h2>
            </div>
          </v-col>
        </v-row>
        <v-row class="submenu-row ma-0">
          <v-col cols="12" md="6" class="d-flex pa-2">
            <div class="submenu frontButton w-100"
              @click="redirectPath('/changePassword')">
              修改密碼
            </div>
          </v-col>
          <v-col cols="12" md="6" class="d-flex pa-2">
            <div class="submenu frontButton w-100"
              @click="redirectPath('/payrollHistoryList')">
              歷史資訊
            </div>
          </v-col>
        </v-row>
      </div>
    </v-row>
  </div>
</template>

<script>

export default {
  name: 'frontPage',
  mounted(){
    this.getDataset()
  },
  data:() => ({
    datasets:{},
    viewStyle:{},
    infoStatus: 0
  }),
  created(){
    this.calculateWindows()
    this.$root.$on('windowInnerHeight',()=>{
      this.calculateWindows()
    })
  },
  watch:{},
  computed: {},
  methods:{
    calculateWindows(){
      this.viewStyle = {height: window.innerHeight-64 + 'px'}
    },
    redirectPath(path, id){
      this.$router.push({path: path, query: {
        id: id,
        pageInfo: '/frontPage',
      }})
    },
    formatMoney(val) {
      if (val === null || val === undefined || val === '') return '0'
      return Number(val).toLocaleString()
    },
    getDataset(){
      var self = this
      var request = {
        method: 'GET',
        url: '/pmAccountingMonthDetailArchivedByUser',
        params: {
          'userId':sessionStorage.getItem('manageMemberUserId'),
          'limit':1000,
          'orders':'id:desc',
        },
      }
      this.$http(request).then(function(response) {
        if(response.data.data.records[0]){
          self.datasets = response.data.data.records[0]
          self.infoStatus = 1
        }else{
          self.infoStatus = 2
        }
      }).catch(()=>{
      }).finally(()=>{
      })
    },
  }
}
</script>

<style>
  .page-bag{
    align-content:center
  }
  .page-container {
    width: 100%;
    max-width: 1000px;
    margin: 0 auto;
    padding: 0 16px;
  }
  .page-title {
    color: #717171;
    margin-top: 20px;
    font-size: 1.6rem;
  }
  .page-subtitle {
    color: #717171;
    margin-bottom: 20px;
    font-size: 1.6rem;
  }
  .salary-card {
    background: #fff;
    border: 1px solid #D9D9D9;
    border-radius: 12px;
    padding: 60px 40px;
  }
  .header-row {
    border-bottom: 1px solid #000;
    padding-bottom: 12px;
    margin-bottom: 16px;
  }
  .header-text {
    font-size: 2rem;
    font-weight: 600;
  }
  .header-col{
    display: block;
  }
  .detail-btn {
    background: #7AC7FC;
    color: #fff;
    border-radius: 20px;
    padding: 0 16px;
  }
  .amount-wrapper {
    display: flex;
    align-items: center;
  }
  .amount-block {
    text-align: left;
    padding: 8px;
  }
  .amount-text {
    font-size: 2rem;
    font-weight: 600;
  }
  .caption-text {
    font-size: 1.2rem;
  }
  .operator {
    width: 40px;
    text-align: center;
    font-size: 24px;
    font-weight: bold;
  }
  .submenu-row .v-col {
    padding: 12px;
  }
  .submenu {
    height: 160px;
    border-radius: 12px;
    background: #fff;
    border: 1px solid #D9D9D9;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.6rem;
    font-weight: 700;
  }

  @media (max-width: 750px) {
    .page-bag{
      align-content:flex-start
    }
    .amount-wrapper {
      flex-direction: column;
      align-items: stretch;
      gap: 10px;
    }
    .operator {
      display: none;
    }
    .amount-block {
      display: flex;
      justify-content: space-between;
    }
    .amount-text {
      font-size: 1.4rem;
    }
    .header-text {
      font-size: 1.5rem;
    }
    .header-col{
      display: none;
    }
    .page-title {
      margin-top: 20px;
      font-size: 1.25rem;
    }
    .page-subtitle {
      margin-bottom: 20px;
      font-size: 1.25rem;
    }
    .submenu {
      height: 120px;
    }
  }
</style>